/* AD needle-ux-1025
   1) Main and sticky variant pickers render radios with the same name and no real form owner, so they share one
      radio group: the sticky one steals :checked and the main picker shows no highlight after landing on ?variant=.
      Give sticky radios their own name and restore the main selection from Ella's checked attribute.
   2) Needle/hook products (snippet ad-needle-ux sets #ad-needle-ux-data): readable "US 5 · 3.75mm" labels, grid,
      sold-out sizes marked like yarn swatches (tz-oos-bar status + shaded/struck/⊘), driven by variant availability.
   3) 10-25 size carry (v2: fallback = nearest in-stock US size, ties to the smaller): needle length links (#ad-nl-data from snippets/ad-needle-length) carry the selected size as ?variant=<id>
      (same size if in stock on the sibling, else its first in-stock size); hrefs follow variant changes.
   4) 10-25 sold-out guard (all products, #ad-pv-data from snippets/ad-needle-ux): a click on a sold-out size/button selects the
      nearest in-stock one with a polite aria-live note; colour swatches are left alone. On load without ?variant=, a sold-out
      default is replaced by the first available variant. Gift cards are skipped. */
(function () {
  'use strict';
  if (window.__adNeedleUx) return;
  window.__adNeedleUx = true;
  var data = {};
  try { data = JSON.parse((document.getElementById('ad-needle-ux-data') || {}).textContent || '{}'); } catch (e) {}
  var oosSet = {};
  (data.oos || []).forEach(function (v) { oosSet[String(v).trim()] = 1; });

  function splitSticky() {
    document.querySelectorAll('variant-selects[data-context^="sticky"] input[type="radio"]').forEach(function (i) {
      if (!/-sticky$/.test(i.name)) {
        var was = i.hasAttribute('checked');
        i.name = i.name.trim() + '-sticky';
        if (was) i.checked = true;
      }
    });
  }
  function restoreMain() {
    document.querySelectorAll('variant-selects[data-context="main"] fieldset').forEach(function (fs) {
      var radios = fs.querySelectorAll('input[type="radio"]');
      if (!radios.length) return;
      var cur = fs.querySelector('input[type="radio"]:checked');
      if (!cur) {
        var sel = ((fs.querySelector('[data-selected-value]') || {}).textContent || '').trim();
        cur = fs.querySelector('input[type="radio"][checked]');
        if (!cur && sel) radios.forEach(function (r) { if (!cur && r.value.trim() === sel) cur = r; });
        if (cur) cur.checked = true;
      }
      if (cur) {
        radios.forEach(function (r) {
          var on = r === cur;
          r.classList.toggle('checked', on);
          var l = r.nextElementSibling;
          if (l && l.tagName === 'LABEL') l.classList.toggle('checked', on);
        });
      }
    });
  }
  function syncSticky() {
    var sv = document.querySelector('variant-selects[data-context^="sticky"]');
    var mv = document.querySelector('variant-selects[data-context="main"]');
    if (!sv || !mv) return;
    mv.querySelectorAll('fieldset input[type="radio"]:checked, select option:checked').forEach(function (mi) {
      var id = mi.dataset.optionValueId; if (!id) return;
      var so = sv.querySelector('[data-option-value-id="' + id + '"]'); if (!so) return;
      if (so.tagName === 'INPUT') {
        var fs = so.closest('fieldset');
        if (!so.checked) so.checked = true;
        if (fs) fs.querySelectorAll('input[type="radio"]').forEach(function (r) {
          var on = r === so; r.classList.toggle('checked', on);
          var l = r.nextElementSibling; if (l && l.tagName === 'LABEL') l.classList.toggle('checked', on);
        });
        var span = fs && fs.querySelector('[data-selected-value]');
        if (span && span.textContent.trim() !== so.value.trim()) span.textContent = so.value;
      } else if (so.tagName === 'OPTION') {
        var sel = so.closest('select'); if (sel && sel.value !== so.value) sel.value = so.value;
      }
    });
  }
  function isOos(input) {
    return input.classList.contains('disabled') || input.disabled || !!oosSet[input.value.trim()];
  }
  function enhanceNeedles() {
    if (!data.needle) return;
    document.querySelectorAll('variant-selects[data-context="main"] fieldset.variant-option--buttons').forEach(function (fs) {
      fs.classList.add('ad-needle-sizes');
      var inputs = [].slice.call(fs.querySelectorAll('input[type="radio"]'));
      var inn = 0;
      inputs.forEach(function (i) {
        var l = i.nextElementSibling;
        if (!l || l.tagName !== 'LABEL') return;
        if (!l.dataset.adFmt) {
          var m = /^\s*(US\s*[\d.\/]+)\s*,\s*(.+?)\s*$/i.exec(i.value);
          if (m) {
            l.textContent = '';
            l.appendChild(document.createTextNode(m[1].replace(/\s+/g, ' ')));
            var s = document.createElement('span'); s.className = 'ad-mm'; s.textContent = '\u00b7 ' + m[2].replace(/\s+/g, ''); l.appendChild(s);
          }
          l.dataset.adFmt = '1';
        }
        var o = isOos(i);
        l.classList.toggle('ad-oos', o);
        var sym = l.querySelector('.ad-sym'); if (sym) sym.remove();
        if (o) { l.setAttribute('title', 'Sold out'); if (!l.querySelector('.visually-hidden')) { var h = document.createElement('span'); h.className = 'visually-hidden'; h.textContent = ' (sold out)'; l.appendChild(h); } }
        else inn++;
      });
      var key = ((fs.querySelector('legend') || {}).textContent || 'Size').split(':')[0].trim().toLowerCase();
      var word = /s$/.test(key) ? key : key + 's';
      var bar = fs.querySelector('.tz-oos-bar');
      if (inputs.length - inn > 0) {
        if (!bar) { bar = document.createElement('div'); bar.className = 'tz-oos-bar'; var p = document.createElement('p'); p.className = 'tz-oos-status'; bar.appendChild(p); var lg = fs.querySelector('legend'); lg ? lg.insertAdjacentElement('afterend', bar) : fs.insertBefore(bar, fs.firstChild); }
        var st = bar.querySelector('.tz-oos-status'), txt = inn + ' of ' + inputs.length + ' ' + word + ' in stock'; if (st.textContent !== txt) st.textContent = txt;
      } else if (bar) bar.remove();
    });
  }
  function quietButtons() {
    document.querySelectorAll('variant-selects fieldset.variant-option--buttons').forEach(function (fs) {
      if (fs.querySelector('.sbs-swatch-item, .swatch')) return;
      fs.classList.add('ad-quiet-oos');
      fs.querySelectorAll('input[type="radio"]').forEach(function (i) {
        var l = i.nextElementSibling; if (!l || l.tagName !== 'LABEL') return;
        var o = i.classList.contains('disabled') || i.disabled;
        var h = l.querySelector('.ad-so');
        var ella = [].some.call(l.querySelectorAll('.visually-hidden:not(.ad-so)'), function (x) { return /sold out|unavailable/i.test(x.textContent); });
        if (ella && h) { h.remove(); h = null; return; }
        if (o && !h && !ella) { h = document.createElement('span'); h.className = 'visually-hidden ad-so'; h.textContent = ' (sold out)'; l.appendChild(h); }
        else if (!o && h) h.remove();
      });
    });
  }
  var pv = {};
  try { pv = JSON.parse((document.getElementById('ad-pv-data') || {}).textContent || '{}'); } catch (e) {}
  function mainVS() { return document.querySelector('variant-selects[data-context="main"]'); }
  function selectedOpt1() {
    var mv = mainVS(); if (!mv) return null;
    var g = mv.querySelector('fieldset, select'); if (!g) return null;
    if (g.tagName === 'SELECT') return g.value;
    var c = g.querySelector('input[type="radio"]:checked');
    return c ? c.value : null;
  }
  function sizeKey(v) { return String(v || '').split(',')[0].toLowerCase().replace(/\s+/g, '').replace(/^us0+(?=\d)/, 'us'); }
  /* US size as a number: "US 000"=-1, "US 00"=-0.5, "US 0"=0, "US 01"=1, "US 10.5"=10.5; null if not "US n". */
  function sizeNum(v) {
    var m = /^us([\d.]+)$/.exec(String(v || '').split(',')[0].toLowerCase().replace(/\s+/g, ''));
    if (!m) return null;
    if (/^0+$/.test(m[1])) return -(m[1].length - 1) * 0.5;
    var n = parseFloat(m[1]); return isNaN(n) ? null : n;
  }
  /* v2: same size in stock -> nearest in-stock US size (ties -> smaller) -> first in-stock. */
  function pickSibVariant(list, val) {
    var ex = null, ky = null, first = null, near = null, nd = Infinity, nn = Infinity, k = sizeKey(val), sn = sizeNum(val);
    (list || []).forEach(function (r) {
      if (!r[2]) return;
      if (!first) first = r;
      if (!ex && val != null && String(r[1]).trim() === String(val).trim()) ex = r;
      if (!ky && val != null && sizeKey(r[1]) === k) ky = r;
      var n = sizeNum(r[1]);
      if (sn != null && n != null) {
        var d = Math.abs(n - sn);
        if (d < nd || (d === nd && n < nn)) { nd = d; nn = n; near = r; }
      }
    });
    var hit = ex || ky || near || first;
    return hit ? hit[0] : null;
  }
  function updateLengthLinks() {
    var el = document.getElementById('ad-nl-data'); if (!el) return;
    var d; try { d = JSON.parse(el.textContent); } catch (e) { return; }
    var val = selectedOpt1(); if (val == null) val = d.sel;
    document.querySelectorAll('a[data-ad-nl-url]').forEach(function (a) {
      var u = a.getAttribute('data-ad-nl-url');
      var id = pickSibVariant((d.sibs || {})[u], val);
      var h = u + (id ? '?variant=' + id : '');
      if (a.getAttribute('href') !== h) a.setAttribute('href', h);
    });
  }
  function isSwatchFs(fs) { return fs.classList.contains('variant-option--swatches') || !!fs.querySelector('.sbs-swatch-item, .swatch, .swatch-item'); }
  function groupVals(vs) {
    return [].slice.call(vs.querySelectorAll('fieldset, select')).map(function (g) {
      if (g.tagName === 'SELECT') return g.value;
      var c = g.querySelector('input[type="radio"]:checked'); return c ? c.value : null;
    });
  }
  function findVariant(vals) {
    var hit = null;
    (pv.v || []).forEach(function (v) { if (!hit && vals.every(function (x, k) { return x == null || String(v.o[k]).trim() === String(x).trim(); })) hit = v; });
    return hit;
  }
  /* Sold out = Ella's disabled class, the needle oos list, or (multi-option) no available variant for this value + the other current picks. */
  function soldOut(i, vs) {
    if (i.classList.contains('disabled') || i.disabled || (data.needle && !!oosSet[i.value.trim()])) return true;
    if (!vs || !pv.v) return false;
    var groups = [].slice.call(vs.querySelectorAll('fieldset, select')), gi = groups.indexOf(i.closest('fieldset'));
    if (gi < 0) return false;
    var vals = groupVals(vs); vals[gi] = i.value;
    var v = findVariant(vals);
    return !!v && !v.a || (!v && groups.length > 1);
  }
  function shortLabel(v) { var m = /^\s*(US\s*[\d.\/]+)/i.exec(v); return m ? m[1].replace(/\s+/g, ' ') : String(v).trim(); }
  function noteFor(vs) {
    var n = vs.nextElementSibling;
    if (n && n.classList.contains('ad-so-note')) return n;
    n = document.createElement('p'); n.className = 'ad-so-note'; n.setAttribute('role', 'status'); n.setAttribute('aria-live', 'polite');
    vs.insertAdjacentElement('afterend', n);
    return n;
  }
  function setNote(vs, txt) { var n = noteFor(vs); n.textContent = txt; n.classList.toggle('is-on', !!txt); }
  function variantIdFor(vs) { var v = pv.v ? findVariant(groupVals(vs)) : null; return v ? v.id : null; }
  function onSoldOutClick(e) {
    var i = e.target;
    if (!i || i.type !== 'radio' || !e.isTrusted || pv.gc) return;
    var vs = i.closest('variant-selects'), fs = i.closest('fieldset');
    if (!vs || !fs || isSwatchFs(fs)) return;
    if (!soldOut(i, vs)) { setNote(vs, ''); return; }
    var inputs = [].slice.call(fs.querySelectorAll('input[type="radio"]')), idx = inputs.indexOf(i), best = null;
    for (var d = 1; d < inputs.length && !best; d++) {
      if (inputs[idx - d] && !soldOut(inputs[idx - d], vs)) best = inputs[idx - d];
      else if (inputs[idx + d] && !soldOut(inputs[idx + d], vs)) best = inputs[idx + d];
    }
    if (!best) return;
    e.stopImmediatePropagation();
    i.checked = false; best.checked = true;
    best.dispatchEvent(new Event('change', { bubbles: true }));
    setNote(vs, shortLabel(i.value) + ' is sold out, showing ' + shortLabel(best.value));
    var id = variantIdFor(vs), tries = 0;
    if (!id) return;
    (function fixUrl() {
      var mv = mainVS(), sv = null;
      try { sv = JSON.parse(mv.querySelector('[data-selected-variant]').textContent); } catch (x) {}
      if (sv && sv.id === id) {
        if (location.search.indexOf('variant=' + id) < 0) {
          var q = new URLSearchParams(location.search); q.set('variant', id);
          history.replaceState(history.state, '', location.pathname + '?' + q.toString() + location.hash);
        }
        updateLengthLinks();
      } else if (++tries < 40) setTimeout(fixUrl, 100);
    })();
  }
  function guardDefault() {
    if (pv.gc || !pv.v || !pv.v.length || /[?&]variant=/.test(location.search)) return;
    var mv = mainVS(); if (!mv) return;
    var sv = null;
    try { sv = JSON.parse(mv.querySelector('[data-selected-variant]').textContent); } catch (e) { return; }
    if (!sv || sv.available) return;
    var first = null;
    pv.v.forEach(function (v) { if (!first && v.a) first = v; });
    if (!first) return;
    var last = null;
    [].slice.call(mv.querySelectorAll('fieldset, select')).forEach(function (g, k) {
      var want = String(first.o[k] == null ? '' : first.o[k]).trim();
      if (g.tagName === 'SELECT') { if (g.value !== want) { g.value = want; last = g; } return; }
      g.querySelectorAll('input[type="radio"]').forEach(function (r) {
        if (r.value.trim() === want && !r.checked) { r.checked = true; last = r; }
      });
    });
    if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function run() { try { splitSticky(); restoreMain(); syncSticky(); quietButtons(); enhanceNeedles(); updateLengthLinks(); } catch (e) {} }
  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(run, 30); }
  function init() {
    document.addEventListener('change', onSoldOutClick, true);
    run();
    try { guardDefault(); } catch (e) {}
    document.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio' && e.target.closest('variant-selects')) setTimeout(run, 0);
    });
    var root = document.querySelector('product-info') || document.body;
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    var sticky = document.querySelector('variant-selects[data-context^="sticky"]');
    if (sticky && !root.contains(sticky)) new MutationObserver(schedule).observe(sticky.parentNode, { childList: true, subtree: true });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
